import { NotFound, NotFoundMessage } from '../Utility/Constants';
import './NotFound.css';

function NotFoundPage() {
    return (
        <>
            <div className='notFounded'>
                <div className='notFound'>{NotFound}</div>
                <p className='notFoundMessage'>{NotFoundMessage}</p>
            </div>
        </>
    )
}

export default NotFoundPage